import React from 'react'
import { AddToChromeButton } from '@mote/presentation'
import { Content, DefaultLayout } from '../layouts'
import styled from 'styled-components'
import { Block, H3, H4, P, Text } from '@mote/ui'

export const LanguagesScreen = () => {
  return (
    <Root>
      <Content>
        <Block
          layout='horizontal'
          gap={50}
          justify='space-between'
          margin='40px 0 40px 0'
        >
          <Block maxWidth={570} justify='center'>
            <H3>
              Remote learning &amp; feedback for ESL &amp; Modern Languages
              students
            </H3>
            <P>
              Learn how <b className='mote-purple'>mote</b> can help ease your
              workload, and help your students stay connected.
            </P>
          </Block>

          <Block as='figure' gap={10}>
            <img
              height='400'
              src='images/photos/languages.jpg'
              title='A teacher uses mote'
              alt='mote demo'
            />
            <figcaption>
              <Text tag='p' fontSize={13} alignment='center'>
                Photo credit: Antoine Dautry, via Unsplash
              </Text>
            </figcaption>
          </Block>
        </Block>

        <Block>
          <P>
            Voice feedback is especially powerful for language learning, because
            teachers can provide guidance on pronunciation in either native
            language, learned language or a mixture of both.
          </P>
          <P>
            <b className='mote-purple'>Mote</b> supports transcription in more
            than twenty languages, and it’s easy to switch between languages
            from voice note to voice note, or to temporarily disable
            transcription if desired.
          </P>
        </Block>

        <div
          className='bg-cover Position-relative'
          style={{
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url(images/logos/mote-background.png',
            backgroundSize: 'auto'
          }}
        >
          <H4>
            Here's what we've heard about <b className='mote-purple'>mote</b>{' '}
            from ESL and Modern Languages teachers
          </H4>

          <Block layout='horizontal' gap={20} margin='40px 0 30px 0'>
            <BlockQuote>
              <P>
                "Writing the same or similar feedback to the different students
                takes a toll. Being able to share ideas through a simple
                recording and for them to either read through or listen as an
                option is awesome. It really helps out my English Language
                Learners."
              </P>
              <div>💜</div>
            </BlockQuote>

            <BlockQuote>
              <P className='text-secondary'>
                “It makes giving feedback easier. It's an excellent way to
                differentiate for students who need to HEAR the feedback. Also,
                I can speak another language better than I can write it so I use
                to speak Spanish to my students who can't speak English."
              </P>
              <div>💜</div>
            </BlockQuote>
          </Block>

          <Block layout='horizontal' gap={20} margin='40px 0 30px 0'>
            <BlockQuote>
              <P>
                “I teach Chinese as a second language. Being able to provide
                oral feedback to the students is absolutely necessary especially
                during the online learning.”
              </P>
              <div>💜</div>
            </BlockQuote>

            <BlockQuote>
              <P className='text-secondary'>
                "Its an awesome tool to give students instant feedback and
                allows them to hear me speak in te reo Māori and English."
              </P>
              <div>💜</div>
            </BlockQuote>
          </Block>

          <Block gap={20} margin='40px 0 40px 0' align='center'>
            <H3 alignment='center'>Start your free trial</H3>
            <AddToChromeButton />
          </Block>
        </div>
      </Content>
    </Root>
  )
}

const Root = styled(DefaultLayout)`
  figure {
    img {
      padding: 0.5rem;
      background-color: #f8f9fa;
      border: 0 solid #dee2e6;
      border-radius: 0.375rem;
      box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
    }
  }
`

const BlockQuote = styled.blockquote`
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  background: white;
  max-width: 48%;
`
